import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BlogPage from '../blog/pages/BlogPage';
import BlogPostPage from '../blog/pages/BlogPostPage';

const BlogRouter = () => (
  <Routes>
    <Route path="" element={<BlogPage />} />
    <Route path=":id" element={<BlogPostPage />} />
  </Routes>
);

export default BlogRouter;

